const faqs = [
    {
        id: 0,
        question: "Which games do you support?",
        answer:
            "We are starting of with League of Legends, VALORANT and Wild Rift. PUBG and CS will be added in the future.",
    },
    {
        id: 1,
        question: "How often is Scoutli updated?",
        answer:
            "The data we provide is updated almost in real time. We will be able to provide the data as soon as matches are completed.",
    },
    {
        id: 2,
        question: "What is Scoutli Rating?",
        answer:
            "Scoutli Rating is a unique metric we use to rank teams and players on an open-bordered scale. It takes hundreds of data points to calculate a rating.",
    },
    {
        id: 3,
        question: "How can I request a feature?",
        answer:
            "We welcome your thoughts and suggestions. Contact us at team@scoutli.co ",
    },
    {
        id: 4,
        question: "How do I request a refund?",
        answer:
            "We can prodive refunds for some purchases, depending on the refund policies. Contact us at team@scoutli.co to learn more.",
    },
    {
        id: 5,
        question: "Do you offer geographical pricing?",
        answer:
            "We know that not everyone earns a US/EUR salary. That’s why, we offer our customers a discount based on their location. Contact us at team@scoutli.co to see if you are eligible.",
    }
]

const FAQ = () => {
    return (
        <div className="bg-white">
            <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                <h2 className="text-3xl font-extrabold text-gray-900 text-center">Frequently asked questions</h2>

                <div className="mt-12">
                    <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12 lg:grid-cols-3">
                        {faqs.map((faq) => (
                            <div key={faq.id}>
                                <dt className="text-lg leading-6 font-medium text-gray-900">{faq.question}</dt>

                                <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    )
}

export default FAQ;
